import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFullScreen: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFullScreen"><Path d="M8.5 3.5H3.5V8.5M15.5 3.5H20.5V8.5M20.5 15.5V20.5H15.5M8.5 20.5H3.5V15.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFullScreen;
